import SkeletonComponent from 'core/components/Skeleton/skeleton';
import React from 'react';
import { SectionSkeletonProps } from '../type';


const SectionSkeleton: React.FC<SectionSkeletonProps> = ({
  width = 160,
  height = 220,
  circle = false,
  count = 4
}) => {
  return (
    <div className='flex rounded-lg'>
      {[...Array(count)].map((_, index) => (
        <SkeletonComponent key={index} className={`flex rounded-lg w-[160px] h-[220px] mb-0 px-3.5 py-4 mr-2`} circle={circle} width={width} height={height} />
      ))}
    </div>
  );
};

export default SectionSkeleton;